import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap'
import { Breadcrumbs, H4 } from '../../AbstractElements'
import { getDataWithoutClass, getDataWithClassId } from '../../lib/studentinfoclassdetail'
import { addData, deleteFromData } from '../../lib/classdetail'
import { getIdData } from '../../lib/classview'
import { StudentCard } from '../Common/StudentCard'
import { useParams } from 'react-router-dom'

const AdminStudentToClass = () => {
	const [allStudents, setAllStudents] = useState([])
	const [classStudent, setClassStudent] = useState([])
	const [classInfo, setClassInfo] = useState()
	const [loading, setLoading] = useState(true)

	let { id } = useParams()

	async function GetStudentWithoutClass() {
		try {
			const profils = await getDataWithoutClass()
			if (profils.length > 0) setAllStudents(profils)
		} catch (error) {
			console.error('Error fetching students without class:', error)
		}
	}

	async function GetClassStudent() {
		try {
			const classinf = await getIdData(id)
			setClassInfo(classinf)
			const clas = await getDataWithClassId(id)
			setClassStudent(clas)
		} catch (error) {
			console.error('Error fetching class students:', error)
		}
	}

	async function AddClassData(studentId) {
		try {
			await addData({
				classId: id,
				instructorId: classInfo[0].instructorId,
				studentId: studentId
			})
			GetClassStudent()
			GetStudentWithoutClass()
		} catch (error) {
			console.error('Error adding student to class:', error)
		}
	}

	async function RemoveClassData(studentId) {
		try {
			await deleteFromData({
				classId: id,
				instructorId: classInfo[0].instructorId,
				studentId: studentId
			})
			GetClassStudent()
			GetStudentWithoutClass()
		} catch (error) {
			console.error('Error removing student from class:', error)
		}
	}

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true)
			await Promise.all([GetClassStudent(), GetStudentWithoutClass()])
			setLoading(false)
		}
		fetchData()
	}, [id])

	if (loading) {
		return (
			<>
				<Breadcrumbs mainTitle="Add Students" parent="Class Management" title="Add Students to Class" />
				<Container fluid={true}>
					<Row>
						<Col sm="12">
							<Card>
								<CardBody>
									<div className="text-center">
										<div className="spinner-border text-primary" role="status">
											<span className="sr-only">Loading...</span>
										</div>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</>
		)
	}

	return (
		<>
			<Breadcrumbs mainTitle="Add Students" parent="Class Management" title="Add Students to Class" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardHeader>
								<H4 attrH4={{ className: 'card-title mb-0' }}>Manage Class Students</H4>
							</CardHeader>
							<CardBody>
								{/* Class Information */}
								<div className="row gx-2 align-items-center mb-4">
									<div className="col-md-6 col-lg-6 col-item">
										<div className="form-group select-form mb-1">
											<label className="form-label">Instructor</label>
											<h4>
												<b>{classInfo && classInfo.length > 0 ? `${classInfo[0].name} ${classInfo[0].surname}` : 'Loading...'}</b>
											</h4>
										</div>
									</div>
									<div className="col-md-6 col-lg-6 col-item mr-2">
										<div className="form-group select-form mb-1">
											<label className="form-label">Class</label>
											<h4>
												<b>{classInfo && classInfo.length > 0 ? classInfo[0].class_name : 'Loading...'}</b>
											</h4>
										</div>
									</div>
								</div>

								{/* Student Management Interface */}
								<div className="row mt-2 gx-5">
									{/* Available Students */}
									<div className="col border border-2 rounded-2 p-2">
										<h5 className="mb-3">Available Students</h5>
										{allStudents.length > 0 ? (
											<Row>
												{allStudents.map((data, ix) => (
													<StudentCard key={ix} data={data} showLinks={false} showEditIcon={false} cardSize="6" className="col-ed-6 box-col-6">
														<button type="button" className="btn btn-success btn-sm" onClick={() => AddClassData(data.studentId || data.id)}>
															Add {'>>'}
														</button>
													</StudentCard>
												))}
											</Row>
										) : (
											<div className="text-center py-5">
												<i className="fa fa-users fa-3x text-muted mb-3"></i>
												<h5 className="text-muted">No available students</h5>
												<p className="text-muted">All students are already assigned to classes.</p>
											</div>
										)}
									</div>

									{/* Class Students */}
									<div className="col">
										<div className="border border-2 rounded-2 p-2 h-100">
											<h5 className="mb-3">Class Students</h5>
											{classStudent.length > 0 ? (
												<Row>
													{classStudent.map((data, ix) => (
														<StudentCard key={ix} data={data} showLinks={false} showEditIcon={false} cardSize="6" className="col-ed-6 box-col-6">
															<button type="button" className="btn btn-danger btn-sm" onClick={() => RemoveClassData(data.studentId || data.id)}>
																{'<<'} Remove
															</button>
														</StudentCard>
													))}
												</Row>
											) : (
												<div className="text-center py-5">
													<i className="fa fa-user-plus fa-3x text-muted mb-3"></i>
													<h5 className="text-muted">Empty Class</h5>
													<p className="text-muted">No students assigned to this class yet.</p>
												</div>
											)}
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminStudentToClass }
